import { SecondaryOfferEntry } from "kreate-common/modules/business-types";
import { z } from "zod";

export const Params = z.object({
  // base filter
  assetId: z.string(),
  // advance filter
  offererStakeAddress: z.string().nullish(),
  userId: z.string().nullish(),
  txId: z.string().nullish(),
  // paging
  offset: z.coerce.number(),
  limit: z.coerce.number(),
});

export type Params = z.infer<typeof Params>;

export const Result = z.object({
  offers: SecondaryOfferEntry.array(),
  count: z.coerce.number(),
});

export type Result = z.infer<typeof Result>;

export const GetSecondaryOffers$Params = Params;
export type GetSecondaryOffers$Params = Params;
export const GetSecondaryOffers$Result = Result;
export type GetSecondaryOffers$Result = Result;
